import React, { useState, useEffect } from 'react';
import reviewIcon from '../images/review.png'; // Renamed this to avoid confusion

const reviews = [
  {
    name: "Mili Mishra",
    reviewCount: 2,
    timeAgo: "a week ago",
    text: "Their work is very best, Even their staff works very well",
    ownerReply: "Thanks a lot 🙏",
    ownerTimeAgo: "a week ago",
    avatar: reviewIcon,
  },
  {
    name: "Rahib Jafri",
    reviewCount: 4,
    timeAgo: "7 months ago",
    text: "Best experience for pvc panel work thanks alot for as traders",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "7 months ago",
    avatar: reviewIcon,
  },
  {
    name: "Aanad Kishor",
    reviewCount: 1,
    timeAgo: "a month ago",
    text: "Best shop pvc panel",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "a month ago",
    avatar: reviewIcon,
  },
  {
    name: "Naren Yadav",
    reviewCount: 4,
    timeAgo: "7 months ago",
    text: "Amazing work experience thanks for suggestion pvc panel 👍",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "7 months ago",
    avatar: reviewIcon,
  },
  {
    name: "Bajrangi Yadav",
    reviewCount: 1,
    timeAgo: "a month ago",
    text: "Best shop wholesale price",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "a month ago",
    avatar: reviewIcon,
  },
  {
    name: "Daniyal Abbas",
    reviewCount: 4,
    timeAgo: "4 years ago",
    text: "Best pvc design at entire latoush road and very reasonable price do visit and make your dream interior as per your budget. Fantastic services provided by shop owner and his workers.",
    ownerReply: "Thanks",
    ownerTimeAgo: "4 years ago",
    avatar: reviewIcon,
  },
  {
    name: "Fajle Rasool1998",
    reviewCount: 1,
    timeAgo: "4 months ago",
    text: "Best shop pvc",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "4 months ago",
    avatar: reviewIcon,
  },
  {
    name: "Jayprakash Verma",
    reviewCount: 1,
    timeAgo: "2 years ago",
    text: "Amazing work pvc panel best shop for Lucknow",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "2 years ago",
    hasPhoto: true,
    avatar: reviewIcon,
  },
];

const Review = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === Math.ceil(reviews.length / 3) - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="review-section">
      <div className="review-header">
       
        <h2>What They Say</h2>
      </div>

      <div className="review-slider">
        <div
          className="review-container"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {Array.from({ length: Math.ceil(reviews.length / 3) }).map((_, groupIndex) => (
            <div className="review-group" key={groupIndex}>
              {reviews.slice(groupIndex * 3, groupIndex * 3 + 3).map((review, idx) => (
                <div className="review-card" key={idx}>
                  <div className="review-avatar">
                    <img src={review.avatar} alt={review.name} /> {/* Changed to review.avatar */}
                  </div>
                  <div className="review-content">
                    <p className="review-text">"{review.text}"</p>
                    <p className="review-author">
                      {review.name} - ⭐⭐⭐⭐⭐
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="review-dots">
        {Array.from({ length: Math.ceil(reviews.length / 3) }).map((_, idx) => (
          <span
            key={idx}
            className={`dot ${currentIndex === idx ? 'active' : ''}`}
            onClick={() => handleDotClick(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default Review;